import { htmlVisualElement } from './html-visual-element.js';
import { svgVisualElement } from './svg-visual-element.js';
import { isSVGComponent } from './utils/is-svg-component.js';

function createDomVisualElement(Component) {
  return function (isStatic, options) {
    var isSVG = isSVGComponent(Component);
    var factory = isSVG ? svgVisualElement : htmlVisualElement;
    return factory(options, {
      enableHardwareAcceleration: !isStatic && !isSVG
    });
  };
}

export { createDomVisualElement };